<template>
  <b-container class="vh-100 d-flex align-items-center justify-content-center">
    <b-card title="Please Log In" class="w-50">
      <b-form @submit.prevent="onSubmit" ref="form">
        <b-form-group label="Username" label-for="username">
          <b-form-input
            id="username"
            v-model.trim="form.username"
            required
            placeholder="Enter username"
          />
        </b-form-group>

        <b-form-group label="Password" label-for="password">
          <b-form-input
            id="password"
            type="password"
            v-model="form.password"
            required
            placeholder="Enter password"
          />
        </b-form-group>

        <b-button
          type="submit"
          variant="primary"
          :disabled="loading"
          block
        >
          <b-spinner small v-if="loading" class="mr-2" /> Login
        </b-button>

        <b-alert
          v-if="error"
          variant="danger"
          show
          class="mt-3"
        >
          {{ error }}
        </b-alert>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
export default {
  name: 'LoginForm',
  data() {
    return {
      loading: false,
      error: null,
      form: {
        username: '',
        password: '',
      },
      VALID: { user: 'martini', pass: 'rea!!y-d1ffIcu1t-F0ggy-Sunr1s3-#tr3rE' },
    }
  },
  methods: {
    onSubmit() {
      this.error = null
      this.loading = true

      // simulate async auth
      setTimeout(() => {
        this.loading = false

        if (
          this.form.username === this.VALID.user &&
          this.form.password === this.VALID.pass
        ) {
          this.$emit('login-success')
        } else {
          this.error = 'Invalid username or password'
        }
      }, 500)
    },
  },
}
</script>

<style scoped>
.vh-100 { height: 100vh; }
</style>